export default __webpack_public_path__ + "static/media/007-rubik cube.9ea34de3.svg";